import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models';

import { UitkCheckbox } from 'uitk-react-checkbox';

import { FormFieldBinding } from 'components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

interface FlightNonStopCheckboxProps extends LocalizedComponentProps, SearchFormFieldProps {
  model: SearchCriteriaModel;
}

@withLocalization
@FormFieldBinding
export class FlightNonStopCheckbox extends React.Component<FlightNonStopCheckboxProps> {
  private name: string;
  private label: string;

  constructor(props: FlightNonStopCheckboxProps) {
    super(props);

    this.name = props.modelKey;
    this.label = props.l10n.formatText('multiItem.searchWizard.directFlightsOnly');

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event) {
    const { updateModel, modelKey } = this.props;

    if (typeof updateModel === 'function') {
      const { checked } = event.target;

      updateModel({
        target: {
          name: modelKey,
          value: String(checked),
          track: true,
        },
      });
    }
  }

  public render() {
    return (
      <div className="uitk-cell s-cell-1-1">
        <UitkCheckbox
          id={this.name}
          name={this.name}
          value={this.props.model.directFlights}
          checked={this.props.model.directFlights === 'true'}
          onChange={this.handleChange}
        >
          {this.label}
        </UitkCheckbox>
      </div>
    );
  }
}
